import React from 'react';
import Surface from 'mini-campaign-surface/lib/components/Surface';
import switchModule from 'owa-mail-store/lib/actions/switchModule';
import { getPushNotificationsSurfaceCustomCallback } from 'mini-webpush-notifications/lib/utils/getPushNotificationsSurfaceCustomCallback';
import { getPushNotificationsSurfaceRealtimeSignals } from 'mini-webpush-notifications/lib/utils/pushNotificationsOnboardingUtils';
import { Module } from 'mini-common-schema';
import { PlacementId } from 'mini-campaign-bootstrap/lib/schema/PlacementId';
import { SettingsSubRoutes } from 'mini-common-schema/lib/schema/SettingsSubRoutes';

export interface MiniPushNotificationsSurfaceProps {
    elementToFocusOnClose?: React.RefObject<any>;
}

export const MiniPushNotificationsSurface = (
    props: MiniPushNotificationsSurfaceProps
): JSX.Element => (
    <Surface
        placementId={PlacementId.MiniPushNotificationsSurface}
        getRealtimeSignals={getPushNotificationsSurfaceRealtimeSignals}
        customCallbackFunctions={getPushNotificationsSurfaceCustomCallback(() => {
            switchModule(Module.Options);
            switchModule(Module.Options, SettingsSubRoutes.Notifications);
        })}
        elementToFocusOnClose={props.elementToFocusOnClose}
    />
);
